import _sfc_main from "./component-library119.mjs";
import "./component-library120.mjs";
import normalizeComponent from "./component-library91.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.InputWrapper, _vm._b({ staticClass: "checkbox-input", attrs: { "large": false, "show-label": "", "medium": false, "inline-label": false }, scopedSlots: _vm._u([{ key: "label", fn: function({ id: wrapperId }) {
    return [_c("input", _vm._b({ staticClass: "checkbox-input__input", class: _vm.inputClass, attrs: { "id": wrapperId, "type": "checkbox", "aria-invalid": !!_vm.errorMessage, "aria-describedby": `${wrapperId}-error` }, domProps: { "value": _vm.value, "checked": !!_vm.value }, on: { "change": _setup.onChange } }, "input", _setup.inputFieldProps, false)), _c("span", { staticClass: "checkbox-input__icon" }), _c("div", [_vm._t("default", function() {
      return [_vm._v(" " + _vm._s(_vm.label) + " ")];
    }), _vm.required && !_vm.hideAsterisk ? _c("span", { staticClass: "input-wrapper__required" }, [_vm._v("*")]) : _vm._e()], 2)];
  } }], null, true) }, "InputWrapper", _setup.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "1bda9cc9",
  null,
  null
);
const checkboxInput = __component__.exports;
export {
  checkboxInput as default
};
